<template>
  <v-content>
    <v-container grid-list-bg class="pb-0" style="background-color:#FFFFFF">
      <template>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

      <v-card-title>
         <v-spacer></v-spacer>
       <v-select
       v-model="slc_unidad"
       label="Unidad:"
       :items="aUnidadesSlc"
       item-text="nombreUnidad"
       item-value="idUnidad"
       @change="dusuer()"
       />
        </v-card-title>
        <template>
          <v-btn
            v-if="usTipo=='Administrador'"
            color="primary"
            @click="dialog = true"
            dark
            class="mb-2"
          >Agregar fracciones</v-btn>
        </template>
        <v-data-table
          :headers="headers"
          :items="desserts"
          sort-by="orden"
          class="elevation-1"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Catálogo de Fracciones</v-toolbar-title>
              <v-divider class="mx-3" inset vertical></v-divider>
              <v-spacer></v-spacer>
                </v-toolbar>
       
              <!-- Termina carga de archivi  -->
          
          </template>

          <template v-slot:item.archivo="{ item }">
            <v-icon
              v-if="item.isPeriodo ==true || usTipo=='Administrador'"
              md
              color="teal darken-2"
              @click="UpArchivo(item)"
            >control_point</v-icon>
            <!-- <v-icon md color="teal darken-2" @click="UpArchivo(item)">control_point</v-icon> -->
            <v-icon md color="orange darken-2" @click="modalitem(item)">visibility</v-icon>
          </template>
          <template v-slot:item.hipervinculos="{ item }">
            <v-icon md color="teal darken-2" @click="UpVinculo(item)">control_point</v-icon>
            <v-icon md color="orange darken-2" @click="modalvinculo(item)">visibility</v-icon>
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon small @click="deleteItem(item)">delete</v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>


        <!--Inicia dialog de iconos  -->

               <v-dialog v-model="dialog" max-width="800px">
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm3 d-flex>
                          <v-text-field
                            v-model="editedItem.numFraccion"
                            label="Fracción"
                          >{{editedItem.idFraccion}}</v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3 d-flex>
                          <v-text-field
                            v-model="editedItem.orden"
                            label="Indice"
                          >{{editedItem.orden}}</v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 d-flex>
                          <v-select
                            v-model="editedItem.idTipoFraccion"
                            :items="respddl"
                            item-text="tipoFraccion"
                            item-value="idTipoFraccion"
                            label="Tipo de fraccion"
                            outlined
                          ></v-select>
                        </v-flex>
                        <v-flex d-flex xs12 sm12 md12>
                          <v-textarea
                            filled
                            auto-grow
                            v-model="editedItem.fraccion"
                            label="Descripción"
                            rows="2"
                            row-height="20"
                          ></v-textarea>
                        </v-flex>

                        <v-flex d-flex xs12 sm6 md12>
                          <v-textarea
                            filled
                            auto-grow
                            v-model="editedItem.descripcionCorta"
                            label="Descripción Corta"
                            rows="2"
                            row-height="20"
                          >{{editedItem.descripcionCorta}}</v-textarea>
                        </v-flex>

                        <v-flex xs12 sm9 d-flex>
                          <v-select
                            v-model="editedItem.idUnidad"
                            :items="respddlF"
                            item-text="nombreUnidad"
                            item-value="idUnidad"
                            label="Unidad"
                            outlined
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm3 d-flex>
                          <v-select
                            v-model="editedItem.aplica"
                            :items="itemaplica"
                            item-text="txt"
                            item-value="value"
                            label="Aplicabilidad"
                            @change="(editedItem.aplica)"
                            outlined
                          ></v-select>
                        </v-flex>
                      </v-layout>
                      <v-list>
                        <v-flex xs12 sm4 d-flex>
                          <v-select
                            v-model="editedItem.idTipoPeriodo"
                            :items="ddlTperiodo"
                            item-text="tipoPeriodo"
                            item-value="idTipoPeriodo"
                            label="Perido"
                            outlined
                          ></v-select>
                        </v-flex>
                        <v-layout wrap>
                          <v-card-actions xs12 sm3 lg4 text-sm-right>
                            <div id="demo" :style="styleHeader">
                              <v-icon size="35" color="white">{{ editedItem.IdIcono }}</v-icon>
                            </div>
                            <v-list-item-title v-if="$dayspan.supports.color">
                              <v-list-item-content>
                                <slot
                                  name="eventDetailsColor"
                                  v-bind="slotData"
                                  :style="styleHeader"
                                >
                                  <!-- prepend-icon="feedback" -->
                                  <v-select
                                    single-line
                                    hide-details
                                    solo
                                    flat
                                    :items="$dayspan.colors"
                                    :color="editedItem.color"
                                    v-model="editedItem.color"
                                  >
                                    <template slot="item" slot-scope="{ item }">
                                      <v-list-item-content>
                                        <div
                                          class="ds-color-option"
                                          :style="{backgroundColor: item.value}"
                                          v-text="item.text"
                                        ></div>
                                      </v-list-item-content>
                                    </template>
                                  </v-select>
                                </slot>
                              </v-list-item-content>
                            </v-list-item-title>
                          </v-card-actions>

                          <v-card-actions xs12 sm3 lg4 text-sm-right>
                            <v-btn
                              :style="styleHeader"
                              class="ma-2"
                              dark
                              @click="dialogIcon = true"
                            >Elige un icono</v-btn>
                          </v-card-actions>
                        </v-layout>
                      </v-list>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Formulario de carga de archivo -->
              <v-dialog v-model="Ardialog" max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Guardar Archivo</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 d-flex>
                          <v-select
                            v-model="editedArchivo.anio"
                            :items="ddlanio"
                            label="Año"
                            item-value="anio"
                            outlined
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 d-flex>
                          <v-select
                            v-model="editedArchivo.IdPeriodo"
                            :items="ddlperiodo"
                            item-text="periodo"
                            item-value="idPeriodo"
                            label="periodo"
                            outlined
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm12 d-flex>
                          <form enctype="multipart/form-data">
                            <input
                              type="file"
                              name="file"
                              ref="files"
                              multiple
                              v-on:change="fileChange($event)"
                            />
                          </form>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="Ardialog = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="upload">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Formulario de carga de Hipervinculo -->
              <v-dialog  :loading="downloadLoading"  v-model="hipdialog" max-width="1200px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Subir Hipervínculos</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm9 d-flex>
                          <v-text-field
                            v-model="editedVinculo.NombreFormulario"
                            label="Nombre Del Hipervínculo "
                          >{{editedItem.NombreFormulario}}</v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3 d-flex>
                          <v-select
                            v-model="editedVinculo.anio"
                            :items="ddlanio"
                            label="Año"
                            item-value="anio"
                            outlined
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm3 d-flex></v-flex>
                        <v-flex xs12 sm12 d-flex>
                          <form enctype="multipart/form-data">
                            <input
                              type="file"
                              name="file"
                              ref="files"
                              multiple
                              v-on:change="fileChange($event)"
                            />
                            <!-- <button type="button" @click="uploadVinculo">Cargar</button> -->
                          </form>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="hipdialog = false">Cancelar</v-btn>
                    <v-btn :loading="downloadLoading"  color="blue darken-1" text @click="uploadVinculo">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

        <v-dialog v-model="dialogIcon" max-width="800px">
          <v-card>
            <v-card-title>
              <span>Selecciona icono</span>
              <div class="flex-grow-1"></div>
              <v-layout align-center justify-center wrap>
                <v-flex v-for="icon in icons" :key="icon.idIcono" ma-2>
                  <!-- prubas de guardado de boto n icono  -->
                  <v-btn icon v-on:click="di(icon.idIcono)" @click="dialogIcon = false">
                    <v-icon>{{ icon.nombre }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <!-- <v-icon>mdi-dots-vertical</v-icon> -->
                  </v-btn>
                </template>
              </v-menu>
            </v-card-title>
          </v-card>
        </v-dialog>

        <dialog-archivo
          :item="DgArchivo"
          :aheaders="arheader"
          :dialog="dialogarchivos"
          :usuariot="tpUsuario"
          :close-dialog="closeDialog"
          :vidempleado="idemp"
          :modalitemDialog="modalitem"
        ></dialog-archivo>
        <!-- ///////////////////Termina dialog tabl Archivos/////////////////////////// -->
        <!-- /////////////////////////////////////Vinculos Tabla Dialog/////////////////////////////////////  -->

        <v-dialog
          v-model="dialogtbl"
          max-width="1100"
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialogtbl = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <!-- <v-toolbar-title>{{ oidcUser.Id_Empleado }}</v-toolbar-title> -->
              <v-toolbar-title>{{FraccionNombre}}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <!-- <v-flex v-model="tablar"> -->
            <v-card>
              <v-data-table
                :headers="viheaders"
                :items="vdesserts"
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Hipervínculo</v-toolbar-title>
                    <v-divider class="mx-3" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template
                  v-slot:item.fechaCreacion="{ item }"
                >{{GetFormattedDate(item.fechaCreacion)}}</template>

                <template v-slot:item.idArchivoFraccion="{ item }">
                  <a
                    :href="geturl(item.idArchivoFraccion)"
                    onclick="javascript:window.open(this.href); return false;"
                  >{{geturl(item.idArchivoFraccion)}}</a>
                </template>

                <template v-slot:no-data>
                  <v-btn color="primary" @click="modalitem">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          </v-card>
        </v-dialog>
        <!-- /////////////////////////////// Termian Hipervimvulos ///////////////////////////////////////  -->
        <v-dialog v-model="aplicadialog" max-width="600px">
          <v-card>
            <v-card-title>
              <v-flex d-flex xs8 sm12 md12>
                <v-textarea
                  filled
                  auto-grow
                  v-model="editedItem.noaplica"
                  label="Motivo"
                  rows="2"
                  row-height="20"
                ></v-textarea>
              </v-flex>
            </v-card-title>
          </v-card>
        </v-dialog>
      </template>
    </v-container>
    <modalDialog :tipo-msj="tipoMsj" :msj-dialog="msjDialog" :close-dialog-confir="closeDialogConfir" ></modalDialog>
  </v-content>
</template>


<script>


import { axiosSingleton } from "@/plugins/axios";
import  fraccionServices  from "../services/FraccionService";

import { mapState, mapGetters, mapActions } from "vuex";
import axunidad from "axios";
import { async } from "q";
import modalDialog from "../components/molecules/ModalMsjConfirm";

//let url_api = 'https://colmenac.ugto.mx/rg/Transparencia/'
//let url_api = 'https://localhost:44340/'
let url_api = 'https://enjambrec.ugto.mx/RG/Transparencia/'

export default {
  components: {
    modalDialog,
    DialogArchivo: () => import("../components/molecules/DialogArchivo")
  },
  data: () => ({
    dts: "",
    nue:"",
      downloadLoading: false,
    folio: [],
    mailPdf: [],
    checkbtn: [],
    dialogtbl: false,
    dialogIcon: false,
    aplicadialog: false,
    idArchvio: 0,
    FraccionNombre: "",
    checkbox1: true,
    selected: [],
      // ddlanio: [new Date().getFullYear()],
     ddlanio: [],
    dialogarchivos: false,
    success: false,
    dialog: false,
    dialogClasificador: false,
    Ardialog: false,
    hipdialog: false,
    search: "",
    slc_unidad: "",
    aUnidadesSlc: [],
    descripcionCorta: "",
    icon: "",
    date: new Date(""),
    icons: "",
    files: "",
    usTipo: "",
    itemaplica: [
      { txt: "Aplíca", value: 1 },
      { txt: "No aplíca", value: 2 }
    ],
    headers: [],
    viheaders: [
      { text: "Archivo ", value: "nombreArchivo" },
      { text: "Año", value: "anio" },
      { text: "Actualización", value: "fechaCreacion", sortable: false },
      { text: "Acción", value: "idArchivoFraccion", sortable: false }
    ],

    aheaders: [],
    editedArchivo: {},
    editedVinculo: {},
    desserts: [],
    vdesserts: [],
    adesserts: [],
    editedIndex: -1,
    editedItem: {
      nombreUnidad: "",
      Siglas: 0,
      idUnidad: 0
    },
    defaultItem: {
      nombreUnidad: "",
      Siglas: 0,
      idUnidad: 0
    },
    respddl: [],
    items: [],
    perido: [],
    respddlF: [],
    ddlperiodo: [],
    ddlTperiodo: [],
    tipoMsj: 0,
    msjDialog: "",
    DgArchivo: {},
    tpUsuario: "",
    idemp: "",
    arheader: []
  }),

  computed: {
    ...mapState(['empleadoDatos']),
    ...mapGetters({
      oidcUser: "oidcStore/oidcUser",
      oidcAccessToken: "oidcStore/oidcAccessToken"
    }),
    slotData() {
      return {
        details: this.details
      };
    },
    styleHeader() {
      return {
        backgroundColor: this.editedItem.color,
        color: this.editedItem.forecolor
      };
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Fraccion" : "Fraccion Unidad";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    Ardialog(val) {
      val || this.close1();
    },
    "editedItem.aplica": function() {
      if (this.editedItem.aplica == 2) {
        this.aplicadialog = true;
      }
    }
  },

  mounted() {
    let self = this;
    console.log('EMPLEADO DAAATOS',this.empleadoDatos);
    self.initialize();
    self.getIcon();
  },

  methods: {
    initialize() {
      let self = this;
      self.ddlfraccion();
      self.ddlTipoPeriodo();
    },

    showDialog(llenapdf) {
      console.log("show", llenapdf);
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.folio(llenapdf).then(r => {
        this.folio = r.data.nombreArchivo;
        console.log("modal archivo retorna", this.folio);
        this.tipoMsj = 4;
        this.msjDialog =
          " Tu archivo con el nombre  " +
          this.folio +
          "  se guardo correctamente, se envio mensaje a tu correo institucional";
      });
    },
    showDialogh() {
      let self = this;
      this.tipoMsj = 4;
      this.msjDialog = "Hipervínculo Guardado correctamente";
    },
    geturl(hipervinculos) {
      return (url_api + "dHipervinculo?id=" + hipervinculos);
    },
    dusuer() {
      let self = this;
 
      this.nue = this.empleadoDatos.Id_Empleado;
 
       console.log("nueb XXXXXX" ,this.empleadoDatos.Id_Empleado);
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.usInicio(this.nue).then(r => {
     
        console.log("EL PERMISO--->", r.data[0]);
        this.dts = r.data[0];
      
        this.usTipo = this.dts.vdescripcion;
        console.log("nue", this.nue);

        if (this.dts.vdescripcion == "Administrador") {
          console.log("Administrador");
          this.headers = [
            { text: "#", value: "numFraccion" },
            { text: "Fraccion", value: "fraccion" },
            { text: "Descripción", value: "descripcionCorta" },
            { text: "Tipo Fraccion", value: "tipoFraccion" },
            { text: "Orden", value: "orden" },
            { text: "Archivo", value: "archivo", sortable: false },
            { text: "Vinculos", value: "hipervinculos", sortable: false },
            { text: "Acción", value: "action", sortable: false }
          ];
          this.aheaders = [
            { text: "Archivo ", value: "nombreArchivo" },
            { text: "Año", value: "anio" },
            { text: "Periodo", value: "periodo" },
            { text: "Actualización", value: "fechaCreacion", sortable: true },
            { text: "Estatus", value: "estatus", sortable: true },
            { text: "Mostrar", value: "checkbtn", sortable: false },
            { text: "Acción", value: "action", sortable: false },
            { text: "Comprobante", value: "Comprobante", sortable: false }
          ];

       
          
        if(this.slc_unidad==null || this.slc_unidad=="" || this.slc_unidad==0)
        {
          var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
          fraccionService
            .getCatFraccion()
            .then(r => {
              this.desserts = r.data;

              console.log("fraccion-administrador", this.desserts);
              self.ComboAno();
            });
        }
        else
        {
          var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
          fraccionService
            .getCatFraccionf(this.slc_unidad)
            .then(r => {
              this.desserts = r.data;
              
              console.log("fraccion-administrador", this.desserts);
              self.ComboAno();             
            });
        }
     
        } else if (this.dts.rnombre == "Obligaciones") {
          console.log("Obligaciones");
          this.headers = [
            { text: "#", value: "numFraccion" },
            { text: "Fraccion", value: "fraccion" },
            { text: "Descripción", value: "descripcionCorta" },
            { text: "Tipo Fraccion", value: "tipoFraccion" },
            { text: "Archivo", value: "archivo", sortable: false },
            { text: "Vinculos", value: "hipervinculos", sortable: false }
          ];
          this.aheaders = [
            { text: "Archivo ", value: "nombreArchivo" },
            { text: "Año", value: "anio" },
            { text: "Periodo", value: "periodo" },
            { text: "Actualización", value: "fechaCreacion" },
            { text: "Estatus", value: "estatus", sortable: true },
            { text: "Acción", value: "action", sortable: false },
            { text: "Comprobante", value: "Comprobante", sortable: false }
          ];
          var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.getCatFraccionUsUn(this.dts)
            .then(r => {
              let resp = r.data;

              this.desserts = [];
              let includ = [];
              resp.map(e => {
                if (this.desserts.length == 0) {
                  this.desserts.push(e);
                  includ.push(e.idFraccion);
                } else {
                  //console.log("algo",this.desserts.includes(e))
                  if (!includ.includes(e.idFraccion)) {
                    this.desserts.push(e);
                    includ.push(e.idFraccion);
                  }
                }
              });
              console.log("fraccion-obligaciones", this.desserts);
              self.ComboAno();
            });
        } else {
          this.headers = [
            { text: "#", value: "numFraccion" },
            { text: "Fraccion", value: "fraccion" },
            { text: "Descripción", value: "descripcionCorta" },
            { text: "Tipo Fraccion", value: "tipoFraccion" },
            { text: "Vinculos", value: "hipervinculos", sortable: false }
          ];
          this.aheaders = [
            { text: "Archivo ", value: "nombreArchivo" },
            { text: "Año", value: "anio" },
            { text: "Periodo", value: "periodo" },
            { text: "Actualización", value: "fechaCreacion" },
            { text: "Acción", value: "action", sortable: false },
            { text: "Comprobante", value: "Comprobante", sortable: false }
          ];
          var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
          fraccionService
            .getCatFraccionUsUn(this.dts)
            .then(r => {
              this.desserts = r.data;

              console.log("fraccion-vinculos", this.desserts);
              self.ComboAno();
            });
        }
      




      });
    },
    //carga de archivos//////////////////////////////////////////////////////////////////////////////////////////////
    fileChange(event) {
      console.log(event.target.files[0]);
      this.files = event.target.files[0];
    },

    async upload() {
      console.log("ID EMPLEADO---->",this.empleadoDatos.Id_Empleado);
      let self = this;
      this.editedArchivos = {
        idFraccion: this.editedArchivo.idFraccion,
        numFraccion: this.editedArchivo.numFraccion,
        tipoFraccion: this.editedArchivo.tipoFraccion,
        aplica: this.editedArchivo.aplica,
        NombreFormulario: this.editedArchivo.NombreFormulario,
        IdUnidad: this.editedArchivo.idUnidad,
        IdPeriodo: this.editedArchivo.IdPeriodo,
        Anio: this.editedArchivo.anio,
        idempleado: this.empleadoDatos.Id_Empleado
      };
      // console.log("editedcargar 2", this.editedArchivos);
      let formData = new FormData();

      formData.append("files", this.files);
      formData.append("jsonString", JSON.stringify(this.editedArchivos));
      // console.log(formData);
      this.Ardialog = false;
      var response = await axunidad
        .post(url_api + "darchivo/",
          formData,
          {
            //  .post(`https://localhost:44340/darchivo/`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
          }
        )
        .then(res => {
          //  alert(res);
          var llenapdf = res.data;
          // console.log("guardado" ,llenapdf);

          this.showDialog(llenapdf);
          // console.log("mandar a pdf",llenapdf);
          //  self.emailcomprobante(llenapdf);
        });
      // console.log("mandar a pdf",editedArchivo);
      // self.emailcomprobante(editedArchivo);

      // eslint-disable-next-line no-console
      // console.log(response);
    },

    async uploadVinculo() {
       this.downloadLoading = true;
      let self = this;
      console.log("edited arch cargar", this.editedArchivo);
      this.editedVinculos = {
        idFraccion: this.editedVinculo.idFraccion,
        tipoFraccion: this.editedVinculo.tipoFraccion,

        Descipcion: this.editedVinculo.NombreFormulario,
        IdUnidad: this.editedVinculo.idUnidad,

        Anio: this.editedVinculo.anio,
        idempleado: this.oidcUser.Id_Empleado
      };
      console.log("guarda", this.editedVinculos);
      let formData = new FormData();

      formData.append("files", this.files);
      formData.append("jsonString", JSON.stringify(this.editedVinculos));
      //////////////////////////
      console.log(formData);
      var response = await axunidad
        .post(url_api + "upvinculo" ,
          formData,
          {
            // .post(`https://localhost:44340/upvinculo/`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
          }
        )
        .then(res => {
          // alert(res.status);
          this.showDialogh();
          this.hipdialog = false;
        })
        .catch(error => {
           alert(error);
           //alert("El tamaño debe ser menor a 30 MB");
        });
      // eslint-disable-next-line no-console
       this.downloadLoading = false;
      console.log(response);
    },
    ///////////////////////////////////Envio de comprobante email///////////////////////////////////////
    emailcomprobante(llenapdf) {
      // console.log("items mail", editedArchivo)
      var item = llenapdf;
      var img = new Image();
      console.log("comprobante", item);
      var movimiento = "";
      if (item.estatus == 1) {
        movimiento = "Alta";
      } else if (item.estatus == 2) {
        movimiento = "Baja";
      } else if (item.estatus == 3) {
        movimiento = "revisión";
      } else if (item.estatus == 4) {
        movimiento = "Reachazado";
      }
      var creacion = item.fechaCreacion.substr(0, 19);
      var pr = item.periodo.substr(0, 4);
      var mailPdf = {
        nounidad: item.nombreUnidad,
        descorta: item.descripcionCorta,
        nufraccion: item.numFraccion,
        periodo: pr,
        Anio: item.anio,
        idArchvio: item.idArchvio,
        movimiento: movimiento,
        periodo: item.periodo,
        anio: item.anio
      };
      // console.log("mailPdf",mailPdf);
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService
        .mailc(mailPdf)
        .then(r => {
          r.data;
        })
        .catch(error => console.error("Error:", error))
        .then(response => console.log("Success:", response));
      console.log("entra a false", item);
    },
    //////////////////////////////////termina envio de email comprobante //////////////////////


    di: function(mensaje) {
      return (this.editedItem.IdIcono = mensaje);
    },

    cmostrar(estatus) {
      if (estatus == 1) {
        return "true";
      } else {
        return "";
      }
    },

    getIcon() {
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService
        .getIcon()
        .then(r => {
          this.icons = r.data.data;
          console.log("Success2:", r.data.data);
        })
        .catch(error => console.error("Error:", error))
        .then(response => console.log("Success:", response));
    },

    async editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      console.log(this.editedItem);
      this.dialog = true;
    },
    async UpArchivo(item) {
      let self = this;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedArchivo = Object.assign({}, item);
      console.log("modal guar archivo", this.editedArchivo);
      self.ddlPeriodo(item);
      this.Ardialog = true;
    },
    async UpVinculo(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedVinculo = Object.assign({}, item);
      console.log("modal guar Vinculo", this.editedVinculo);
      this.hipdialog = true;
    },

    modalitem(item) {
      this.idemp = this.dts.vidempleado;
      this.tpUsuario = this.dts.vdescripcion;
      this.dialogarchivos = true;
      this.DgArchivo = item;
      this.arheader = this.aheaders;
      console.log("dg", this.DgArchivo);
    },

    //////////////////Listado de Hipervinculos/////////////////

    modalvinculo(item) {

      this.FraccionNombre = item.descripcionCorta;

      const index = this.desserts.indexOf(item);
      console.log("tblhiperv", item);
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService

        .tblvinculos(item.idFraccion)
        .then(r => {
          this.vdesserts = r.data;
          console.log("modalitemsadeserts", this.vdesserts);
        });

      this.dialogtbl = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      var r =
        confirm("Se eliminara la fraccion") && this.desserts.splice(index, 1);
      if (r.length == 1) {
        //Editar Unidad
        var Estatus = 1;
        var verdadero = { IdFraccion: item.idFraccion, Estatus };
        this.editedItem = Object.assign({}, verdadero);
        console.log("fraccion cambio de status ", this.editedItem);
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
        fraccionService
          .EstausFraccion(self.editedItem)
          .then(r => {
            r.data;
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));

        console.log("entra a true", item);
      } else {
        console.log("cancelar");
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    close1() {
      this.dialogarchivos = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      let self = this;
      if (this.editedIndex > -1) {
        //Editar Unidad
        console.log("editar save", this.editedItem);
       
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService
          .updateFraccion(self.editedItem)
          .then(r => {
            r.data;
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));
      } else {
        //Guardar Unidad
        console.log("guardado", this.editedItem);
        this.desserts.push(this.editedItem);
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
        fraccionService
          .addFraccion(self.editedItem)
          .then(r => {
            self.initialize();
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));
      }
      this.close();
    },

    ddlfraccion() {
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.getCatFraccion().then(c => {
        this.respddl = c.data;
        this.respddls = Object.assign({}, this.respddl);
        console.log("viendo las fracciones", this.respddl);
        // console.log(this.respddl.idTipoFraccion);
      });
      //this.ddlPeriodo();
      this.ddlunidad();
    },

    ddlPeriodo(item) {
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
     
       console.log("id tipo periodo",item)
      fraccionService
        .getCatPeriodoFraccion(item)
        .then(r => {
          this.ddlperiodo = r.data;

          console.log("perido", this.ddlperiodo);
        });

        this.ddlunidad();
    },

    // ddl Uniidad
    ddlunidad() {
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.getCatUnidad().then(c => {
        this.respddlF = c.data.data;    

          var objUnidad = {};
          objUnidad.idUnidad=0;
          objUnidad.nombreUnidad="Ver Todos";
          this.aUnidadesSlc.push(objUnidad);

          c.data.data.forEach(ele => {
          var objUnidad = {};
          objUnidad.idUnidad=ele.idUnidad;
          objUnidad.nombreUnidad=ele.nombreUnidad;
          this.aUnidadesSlc.push(objUnidad);  
        });
      });   

      //console.log("ddlUnidad", this.aUnidadesSlc);
      // self.ComboAno();
      this.dusuer();
    },

    ComboAno() {
      let self = this;
      var d = new Date();
      var n = d.getFullYear();
      var ac = n-1;
      // this.ddlanio=n;
      // console.log("1añossss",n);
      for (var i = n; i >= ac; i--) {
        this.ddlanio[i] = i;
      
      }
      this.ddlanio = this.ddlanio.filter(function (el) {
  return el != null;
});
  console.log("ddlsaño", this.ddlanio);
    },
    ddlTipoPeriodo() {
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService.getTipoPeriodo().then(c => {
        this.ddlTperiodo = c.data;
        console.log("tipoperido", this.ddlTperiodo);
      });
    },
    GetFormattedDate(fechaCreacion) {
      //  console.log("dssd", fechaCreacion);
      (fechaCreacion = fechaCreacion.substr(0, 10)),
        console.log("dssdssd", fechaCreacion);
      return fechaCreacion;
    },
    closeDialog(doRefreshTable) {
      this.dialogarchivos = false;
    },
    closeDialogConfir(){
      this.tipoMsj = 0;
    //  var dialogAlert= false;
    },
  }
};
</script>

